export const CHILDREN_REQUEST = 'organization/CHILDREN_REQUEST';
export const CHILDREN_SUCCESS = 'organization/CHILDREN_SUCCESS';
export const CHILDREN_FAILURE = 'organization/CHILDREN_FAILURE';

export const HIERARCHY_REQUEST = 'organization/HIERARCHY_REQUEST';
export const HIERARCHY_SUCCESS = 'organization/HIERARCHY_SUCCESS';
export const HIERARCHY_FAILURE = 'organization/HIERARCHY_FAILURE';

export const PARENT_HIERARCHY_REQUEST = 'organization/PARENT_HIERARCHY_REQUEST';
export const PARENT_HIERARCHY_SUCCESS = 'organization/PARENT_HIERARCHY_SUCCESS';
export const PARENT_HIERARCHY_FAILURE = 'organization/PARENT_HIERARCHY_FAILURE';

export const GET_ORGANIZATION_REQUEST = 'support/GET_ORGANIZATION_REQUEST';
export const GET_ORGANIZATION_SUCCESS = 'support/GET_ORGANIZATION_SUCCESS';
export const GET_ORGANIZATION_FAILURE = 'support/GET_ORGANIZATION_FAILURE';

export const GET_ORGANIZATION_USERS_REQUEST = 'organization/GET_ORGANIZATION_USERS_REQUEST';
export const GET_ORGANIZATION_USERS_SUCCESS = 'organization/GET_ORGANIZATION_USERS_SUCCESS';
export const GET_ORGANIZATION_USERS_FAILURE = 'organization/GET_ORGANIZATION_USERS_FAILURE';

export const UPDATE_CLIENT_URL_AND_HOTLINE_REQUEST = 'organization/UPDATE_CLIENT_URL_AND_HOTLINE_REQUEST';
export const UPDATE_CLIENT_URL_AND_HOTLINE_FAILURE = 'organization/UPDATE_CLIENT_URL_AND_HOTLINE_FAILURE';
export const UPDATE_CLIENT_URL_AND_HOTLINE_SUCCESS = 'organization/UPDATE_CLIENT_URL_AND_HOTLINE_SUCCESS';

export const UPDATE_CLIENT_URL_STRING_REQUEST = 'organization/UPDATE_CLIENT_CONFIG_URL_REQUEST';
export const UPDATE_CLIENT_URL_STRING_SUCCESS = 'organization/UPDATE_CLIENT_CONFIG_URL_SUCCESS';
export const UPDATE_CLIENT_URL_STRING_FAILURE = 'organization/UPDATE_CLIENT_CONFIG_URL_FAILURE';

export const UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_REQUEST = 'organization/UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_REQUEST';
export const UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_SUCCESS = 'organization/UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_SUCCESS';
export const UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_FAILURE = 'organization/UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_FAILURE';

export const GET_ORGANIZATION_SUBSCRIPTIONS_REQUEST = 'organization/GET_ORGANIZATION_SUBSCRIPTIONS_REQUEST';
export const GET_ORGANIZATION_SUBSCRIPTIONS_SUCCESS = 'organization/GET_ORGANIZATION_SUBSCRIPTIONS_SUCCESS';
export const GET_ORGANIZATION_SUBSCRIPTIONS_FAILURE = 'organization/GET_ORGANIZATION_SUBSCRIPTIONS_FAILURE';

export const UPDATE_ORGANIZATION_SUBSCRIPTIONS_REQUEST = 'organization/UPDATE_ORGANIZATION_SUBSCRIPTIONS_REQUEST';
export const UPDATE_ORGANIZATION_SUBSCRIPTIONS_FAILURE = 'organization/UPDATE_ORGANIZATION_SUBSCRIPTIONS_FAILURE';
export const UPDATE_ORGANIZATION_SUBSCRIPTIONS_SUCCESS = 'organization/UPDATE_ORGANIZATION_SUBSCRIPTIONS_SUCCESS';

export const GET_ORGANIZATION_ACTIVE_SEATS_REQUEST = 'organization/GET_ORGANIZATION_ACTIVE_SEATS_REQUEST';
export const GET_ORGANIZATION_ACTIVE_SEATS_SUCCESS = 'organization/GET_ORGANIZATION_ACTIVE_SEATS_SUCCESS';
export const GET_ORGANIZATION_ACTIVE_SEATS_FAILURE = 'organization/GET_ORGANIZATION_ACTIVE_SEATS_FAILURE';

export const UPDATE_ORGANIZATION_MAX_SEATS_REQUEST = 'organization/UPDATE_ORGANIZATION_MAX_SEATS_REQUEST';
export const UPDATE_ORGANIZATION_MAX_SEATS_SUCCESS = 'organization/UPDATE_ORGANIZATION_MAX_SEATS_SUCCESS';
export const UPDATE_ORGANIZATION_MAX_SEATS_FAILURE = 'organization/UPDATE_ORGANIZATION_MAX_SEATS_FAILURE';

export const GET_ORGANIZATION_ROLES_REQUEST = 'organization/GET_ORGANIZATION_ROLES_REQUEST';
export const GET_ORGANIZATION_ROLES_SUCCESS = 'organization/GET_ORGANIZATION_ROLES_SUCCESS';
export const GET_ORGANIZATION_ROLES_FAILURE = 'organization/GET_ORGANIZATION_ROLES_FAILURE';

export const GET_ORGANIZATION_PERMISSIONS_HIERARCHY_REQUEST =
  'organization/GET_ORGANIZATION_PERMISSIONS_HIERARCHY_REQUEST';
export const GET_ORGANIZATION_PERMISSIONS_HIERARCHY_SUCCESS =
  'organization/GET_ORGANIZATION_PERMISSIONS_HIERARCHY_SUCCESS';
export const GET_ORGANIZATION_PERMISSIONS_HIERARCHY_FAILURE =
  'organization/GET_ORGANIZATION_PERMISSIONS_HIERARCHY_FAILURE';

export const CREATE_CUSTOM_ROLE_REQUEST = 'organization/CREATE_CUSTOM_ROLE_REQUEST';
export const CREATE_CUSTOM_ROLE_SUCCESS = 'organization/CREATE_CUSTOM_ROLE_SUCCESS';
export const CREATE_CUSTOM_ROLE_FAILURE = 'organization/CREATE_CUSTOM_ROLE_FAILURE';

export const GET_ORGANIZATION_ROLE_USER_COUNT_REQUEST = 'organization/GET_ORGANIZATION_ROLE_USER_COUNT_REQUEST';
export const GET_ORGANIZATION_ROLE_USER_COUNT_SUCCESS = 'organization/GET_ORGANIZATION_ROLE_USER_COUNT_SUCCESS';
export const GET_ORGANIZATION_ROLE_USER_COUNT_FAILURE = 'organization/GET_ORGANIZATION_ROLE_USER_COUNT_FAILURE';

export const BULK_REASSIGN_REQUEST = 'organization/BULK_REASSIGN_REQUEST';
export const BULK_REASSIGN_SUCCESS = 'organization/BULK_REASSIGN_SUCCESS';
export const BULK_REASSIGN_FAILURE = 'organization/BULK_REASSIGN_FAILURE';

export const GET_ORGANIZATION_ROLE_DETAIL_REQUEST = 'organization/GET_ORGANIZATION_ROLE_DETAIL_REQUEST';
export const GET_ORGANIZATION_ROLE_DETAIL_SUCCESS = 'organization/GET_ORGANIZATION_ROLE_DETAIL_SUCCESS';
export const GET_ORGANIZATION_ROLE_DETAIL_FAILURE = 'organization/GET_ORGANIZATION_ROLE_DETAIL_FAILURE';

export const UPDATE_CUSTOM_ROLE_REQUEST = 'organization/UPDATE_CUSTOM_ROLE_REQUEST';
export const UPDATE_CUSTOM_ROLE_SUCCESS = 'organization/UPDATE_CUSTOM_ROLE_SUCCESS';
export const UPDATE_CUSTOM_ROLE_FAILURE = 'organization/UPDATE_CUSTOM_ROLE_FAILURE';

export const DELETE_CUSTOM_ROLE_REQUEST = 'organization/DELETE_CUSTOM_ROLE_REQUEST';
export const DELETE_CUSTOM_ROLE_SUCCESS = 'organization/DELETE_CUSTOM_ROLE_SUCCESS';
export const DELETE_CUSTOM_ROLE_FAILURE = 'organization/DELETE_CUSTOM_ROLE_FAILURE';

export const BULK_ASSIGN_REQUEST = 'organization/BULK_ASSIGN_REQUEST';
export const BULK_ASSIGN_SUCCESS = 'organization/BULK_ASSIGN_SUCCESS';
export const BULK_ASSIGN_FAILURE = 'organization/BULK_ASSIGN_FAILURE';
